import css from './style.module.scss';
import {FC} from "react";

type Props = {
    isShowing: boolean,
    isPrev: boolean,
}
const S1: FC<Props> = ({
    isShowing,
    isPrev
}) => {

    const type = isPrev ? "prev" : isShowing ? "show" : "hide";
    return (
        <div className={css.content} data-type={type}>
            <div className={css.hero}>
                <img src={"./images/hero.png"} alt={"Hero banner"}/>
            </div>
            <div className={css.textWrapper}>
                <div className={css.text}>Gaano ka ka-handa sa life?</div>
                <div className={css.text2}>Let's play the Wheel of Life!</div>
            </div>
        </div>
    )
}

export default S1;